<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'SELECT_EXPERTISE_AREAS' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar [(ngModel)]="searchTerm" [placeholder]="'SEARCH' | translate" animated="true"></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none">
    <ion-item *ngFor="let area of filteredAreas">
      <ion-checkbox
        slot="start"
        [checked]="isSelected(area)"
        (ionChange)="selectArea(area)">
      </ion-checkbox>
      <ion-label>{{ area.name | translate }}</ion-label>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding-horizontal">
    <ion-button expand="block" (click)="closeModal()" color="tertiary">{{ 'DONE' | translate }}</ion-button>
  </ion-toolbar>
</ion-footer>